<svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
>
    <path
        d="M17.5151 7.29688H10.9202C9.35918 7.29688 8.09375 8.59765 8.09375 10.2022V16.9814C8.09375 18.586 9.35918 19.8868 10.9202 19.8868H17.5151C19.0761 19.8868 20.3415 18.586 20.3415 16.9814V10.2022C20.3415 8.59765 19.0761 7.29688 17.5151 7.29688Z"
        fill="white"
        fill-opacity="0.8"
    />
    <path
        d="M17.5145 6.61719H10.9195C8.99429 6.61719 7.43359 8.22147 7.43359 10.2005V16.9796C7.43359 18.9586 8.99429 20.5629 10.9195 20.5629H17.5145C19.4397 20.5629 21.0004 18.9586 21.0004 16.9796V10.2005C21.0004 8.22147 19.4397 6.61719 17.5145 6.61719Z"
        stroke="#9A9A9A"
        stroke-width="1.5"
    />
    <path
        d="M13.7534 4.38281H7.15844C5.59746 4.38281 4.33203 5.68359 4.33203 7.28817V14.0673C4.33203 15.6719 5.59746 16.9727 7.15844 16.9727H13.7534C15.3144 16.9727 16.5798 15.6719 16.5798 14.0673V7.28817C16.5798 5.68359 15.3144 4.38281 13.7534 4.38281Z"
        fill="white"
    />
    <path
        d="M13.7527 3.70312H7.15778C5.23257 3.70312 3.67188 5.30741 3.67188 7.2864V14.0656C3.67188 16.0446 5.23257 17.6488 7.15778 17.6488H13.7527C15.6779 17.6488 17.2386 16.0446 17.2386 14.0656V7.2864C17.2386 5.30741 15.6779 3.70312 13.7527 3.70312Z"
        stroke="#9A9A9A"
        stroke-width="1.5"
    />
</svg>
